import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import StateObserver from 'src/StateObserver';
import { openNativeAppStorePage } from '../native.util';
import { AssetGroup } from '@play-co/timestep-core';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import popups from 'src/lib/ui/config/popups';

const ui = uiConfig.buruburu.invite.confirm;

export default class PopupUpdateAppIncentivised extends PopupBasic {
  constructor(opts: { superview: View; close: VoidFunction }) {
    super({
      superview: opts.superview,
      close: () => opts.close(),
      zIndex: 10000,
      width: popups.buruburu.width,
      height: 690,
      darkerBg: false,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.UPDATE_APP_POPUP_INCENTIVISED,
      },
    });

    // Create graphic image
    new ImageScaleView({
      superview: this.box,
      image: 'assets/ui/updateApp/update_app_incentivised.png',
      width: 440,
      height: 329,
      x: this.box.style.width / 2,
      y: 255,
      centerOnOrigin: true,
    });

    // Create divider line
    const lineWidth = 495;
    new View({
      superview: this.box,
      width: lineWidth,
      x: this.box.style.width / 2 - lineWidth / 2,
      y: 440,
      height: 4,
      backgroundColor: '#FDC381',
    });

    // Update message label and position
    this.message.updateOpts({
      ...ui.message,
      width: this.box.style.width - 60,
      height: 150,
      x: 30,
      y: 425,
    });

    // Create CTA button
    new ButtonScaleViewWithText({
      ...ui.okButton,
      superview: this.box,
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: this.box.style.height - 85,
      width: 328,
      height: 87,
      localeText: () => i18n('native.updateIncentivised.cta'),
      onClick: async () => {
        sounds.sfx.play('ok');
        openNativeAppStorePage({
          tracking: {
            origin: 'launch',
            feature: Feature.NATIVE._,
            subFeature: Feature.NATIVE.UPDATE_APP_POPUP_INCENTIVISED,
            timestamp: StateObserver.now(),
          },
        });
      },
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.UPDATE_APP_POPUP_INCENTIVISED_CTA,
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(AssetGroup.constructURLs(['assets/ui/updateApp/']));
  }

  public init(opts: { hardUpdate?: boolean }) {
    super.init({
      title: i18n('native.updateIncentivised.title'),
      message: i18n('native.updateIncentivised.body'),
    });

    if (opts.hardUpdate) {
      this.buttonClose.removeFromSuperview();
    }
  }
}
